module.exports = __webpack_public_path__ + "img/banner1.2db0e91b.jpg";